import ValidatorResult from "../classes/validator.results";
export default class LengthValidationRule {
    name = 'len';
    validate(validation, rule, value, object, manager) {
        let tMin = rule.props.minlen;
        let tMax = rule.props.maxlen;
        //Data
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        if (/(string|array)/.test(typeof value) === false)
            return new ValidatorResult(false, "Ungültiger Eingabe-Wert");
        if (tMin > 0 && tMax > 0 && value.length > 0 && tMax === tMin) {
            if (value.length !== tMax) {
                return new ValidatorResult(false, host.localizer?.tc('system.Validation.StringLengthExact', [validation.displayName, tMax, tMin]));
            }
            else {
                return new ValidatorResult(true);
            }
        }
        else if (tMin > 0 && tMax > 0 && value.length > 0 && (value.length > tMax || value.length < tMin)) {
            return new ValidatorResult(false, host.localizer?.tc('system.Validation.StringLengthMinMax', [validation.displayName, tMax, tMin]));
        }
        else if (tMax > 0 && value.length > 0 && (value.length > tMax)) {
            return new ValidatorResult(false, host.localizer?.tc('system.Validation.StringLengthMax', [validation.displayName, tMax, '']));
        }
        else if (tMin > 0 && value.length > 0 && (value.length < tMin)) {
            return new ValidatorResult(false, host.localizer?.tc('system.Validation.StringLengthMin', [validation.displayName, '', tMin]));
        }
        return new ValidatorResult(true);
    }
}
